<template>
  <header class="page-intro">
    <span class="page-intro__eyebrow">PINKKI / {{ label }}</span>
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
    <slot />
  </header>
</template>
<script>
export default {
  props: {
    label: { type: String, default: "粉红科技" },
    title: { type: String, required: true },
    description: { type: String, default: "" },
  },
};
</script>
